import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { ChatBubble } from "@pcln/horizon";
import { isFuture } from "date-fns/isFuture";
import { isToday } from "date-fns/isToday";
import { parseISO } from "date-fns/parseISO";
import { Box, Button, Text } from "pcln-design-system";
import react, { memo, useContext } from "react";
import { TravelBotLogoImage } from "../../TravelBotLogoImage.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { ChatMessage } from "../CustomChatMessage/index.js";
import MessageFooter from "../MessageFooter/MessageFooter.js";
import { ListOfDifferentTrips } from "./ListOfTrips.js";
import { MyTripDataProvider } from "./myTripDataContext.js";
const Trips = ({ trips = [], deepLinkPrompt, tripHeaderMsg = "I'm happy to help! Below are your trips, please select the one you need help with:", hasMoreTrips = false, displayInRealtimeVoice = false, submitChatMessageInMarkerComponent })=>{
    const currentTrips = [];
    const upcomingTrips = [];
    const pastTrips = [];
    const canceledTrips = [];
    const { setiValues } = useContext(ChatbotDataContext);
    trips.map((trip)=>{
        const checkStartDate = trip?.travelStartDate || new Date().toISOString();
        const checkEndDate = trip?.travelEndDate || new Date().toISOString();
        const travelStart = parseISO(checkStartDate);
        const travelEnd = parseISO(checkEndDate);
        const isCurrentTrip = !trip.isCanceled && (isToday(travelStart) || !isFuture(travelStart) && isFuture(travelEnd));
        const isUpcomingTrip = !trip.isCanceled && !isToday(travelStart) && isFuture(travelStart);
        const isPastTrip = !trip.isCanceled && !isToday(travelStart) && !isFuture(travelStart) && !isFuture(travelEnd);
        if (isCurrentTrip) currentTrips.push(trip);
        else if (isUpcomingTrip) upcomingTrips.push(trip);
        else if (isPastTrip) pastTrips.push(trip);
        else if (trip.isCanceled) canceledTrips.push(trip);
    });
    if (displayInRealtimeVoice) return /*#__PURE__*/ jsx(MyTripDataProvider, {
        currentTrips: currentTrips,
        upcomingTrips: upcomingTrips,
        pastTrips: pastTrips,
        canceledTrips: canceledTrips,
        deepLinkPrompt: deepLinkPrompt,
        children: /*#__PURE__*/ jsx(ListOfDifferentTrips, {})
    });
    const content = /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Text, {
                mb: 2,
                children: tripHeaderMsg
            }),
            /*#__PURE__*/ jsx(MyTripDataProvider, {
                currentTrips: currentTrips,
                upcomingTrips: upcomingTrips,
                pastTrips: pastTrips,
                canceledTrips: canceledTrips,
                deepLinkPrompt: deepLinkPrompt,
                submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent,
                children: /*#__PURE__*/ jsx(ListOfDifferentTrips, {})
            })
        ]
    });
    return trips?.length && !displayInRealtimeVoice ? /*#__PURE__*/ jsxs(react.Fragment, {
        children: [
            /*#__PURE__*/ jsx(Box, {
                mb: 3,
                children: setiValues?.shouldEnablePortalUpdates ? /*#__PURE__*/ jsx(ChatBubble, {
                    role: "response",
                    showResponseIcon: true,
                    slots: {
                        wrapperSlot: 'pb-1',
                        containerSlot: '',
                        contentSlot: '',
                        responseIconSlot: '',
                        footerSlot: ''
                    },
                    children: content
                }) : /*#__PURE__*/ jsx(ChatMessage, {
                    ml: "",
                    mb: "8px",
                    variation: 'initial',
                    Icon: TravelBotLogoImage,
                    message: content,
                    footer: /*#__PURE__*/ jsx(MessageFooter, {})
                })
            }),
            hasMoreTrips ? /*#__PURE__*/ jsx(Box, {
                ml: 3,
                children: /*#__PURE__*/ jsx(Button, {
                    onClick: function() {
                        window.open('/next-profile/trips');
                    },
                    variation: "subtle",
                    children: "View All Trips"
                })
            }) : null
        ]
    }) : null;
};
const Trips_Trips = /*#__PURE__*/ memo(Trips);
export { Trips_Trips as default };
